<template>
  <div v-if="show" class="modal-root">

    <!-- overlay -->
    <div class="modal-overlay" @click="closeModal"></div>

    <!-- modal -->
    <div class="start__modal" @click.stop>
      <div class="start__modal-wrapper">

        <div class="start__modal-head">

          <v-btn 
            @click="closeModal"
            class="start__modal-close-btn"
            icon="mdi mdi-close"
            variant="text"
            aria-label="Zamknij okno"
          />
        </div>

        <div class="start__modal-scroll-container">
          <div class="start__modal-scroll-content">

            <button @click="closeModal" class="start__modal-link" aria-label="Pokaż portal ITS Bielsko-Biała">
              <img v-if="getContrastActive" :src="require('@/assets/img/start_modal/app_startpage_itsbb_button_on_min.svg')" alt="ITS BB"/>
              <img v-else :src="require('@/assets/img/start_modal/app_startpage_itsbb_button_off_min.svg')" alt="ITS BB"/>
            </button>

            <a href="https://rozklady.bielsko.pl/" class="start__modal-link" target="_blank" title="Pokaż rozkłady">
              <img v-if="getContrastActive" 
              :src="require('@/assets/img/start_modal/app_startpage_transport_button_on_min.svg')" alt="Rozkłady"/>
              <img v-else :src="require('@/assets/img/start_modal/app_startpage_transport_button_off_min.svg')" alt="Rozkłady"/>
            </a>

          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script lang="ts">
import { computed, defineComponent, Ref, watch } from 'vue';
import store from '@/store';

export default defineComponent({
  name: 'StartModal',

  props: {
    show: {
      type: Boolean,
      default: true,
    },
  },

  setup(props) {
    const getContrastActive: Ref<boolean> = computed((): boolean => store.getters.getContrastActive);
      
    const closeModal = () => {
      store.commit('closeStartModal');
    };


    // blokada scrolla body
    watch(
      () => props.show,
      (val) => {
        document.body.style.overflow = val ? 'hidden' : '';
      },
      { immediate: true }
    );

    return {
      closeModal,
      getContrastActive,
    };
  },
});
</script>

<style lang="scss">
.modal-root {
  position: fixed;
  inset: 0;
  z-index: 999;
}

// overlay (blur + przyciemnienie)
.modal-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  animation: fadeIn 0.2s ease;
}

// modal
.start__modal {
  font-family: $main-font-family;
  position: absolute;
  width: 900px;
  max-width: 100%;
  padding: rem(25px) rem(5px);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  border-radius: rem(9px);
  color: $modal-font-color;
  background-color: white;
  background-image: url("@/assets/img/start_modal/modal_bg_2.png");
  background-size: cover;
  background-position: center;
  border: rem(1px) solid $border-grey;
  box-shadow: 0 0 10px rgba(#000000, 0.3);
  height: calc(70vh - 82px);
  animation: scaleIn 0.2s ease;

  .dark-theme & {
    background-image: url("@/assets/img/start_modal/modal_bg.png");
    background-color: $dark-static;
    border: rem(2px) solid $yellow-static;
  }

  @include width-until($mobile) {
    max-width: 90%;
    height: calc(94vh - 82px);
  }

  &-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  &-head {
    padding: 0 rem(18px);
    margin: 16px 0;
    text-align: center;

    @include width-until($mobile) {
      padding: 0 rem(6px);
    }

    &-title {
      font-size: rem(26px);
      font-weight: 700;
      letter-spacing: 1px;
      margin-bottom: 4px;
    }
  }

  &-scroll-container {
    overflow: auto;
    height: 100%;
  }

  &-scroll-content {
    padding: 0 rem(18px);
    display: flex;
    justify-content: center;
    align-items: center;
    gap: rem(20px);
    margin-top: 13vh;

    @include width-until($mobile) {
      padding: 0 rem(6px);
      flex-direction: column;
    }
  }

  &-close-btn {
    position: absolute;
    top: rem(8px);
    right: rem(10px);
    border-radius: 50%;
    height: rem(24px);
    width: rem(24px);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    i {
      color: $modal-font-color;
      font-weight: 600;
      font-size: rem(34px);
      .dark-theme & {
        background-color: $dark-static;
      }
    }
  }

  &-link {
    display: inline-block;
    margin-bottom: rem(14px);

    img {
      transition: 0.3s;
      width: 20rem;

      &:hover {
        transform: scale(1.05);
      }

      @include width-until($mobile) {
        max-width: 12rem;
      }
    }
  }
}

// animacje
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes scaleIn {
  from {
    transform: translate(-50%, -60%) scale(0.95);
    opacity: 0;
  }
  to {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
}
</style>